import React, { useState, useEffect } from 'react';
import { Loading } from 'react-admin';
import { TextField, Button, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import dataProvider from '../../../providers/dataProvider';

const headCellStyle = { color: '#8a93a3', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.05em' };

// Histórico de custo do tipo: nunca edita uma linha existente, só cria uma
// vigência nova (effective_from) — é assim que o painel garante que mudar o
// custo não reescreve relatórios de meses já fechados.
const CostHistory = ({ record }) => {
  const [costs, setCosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unitCost, setUnitCost] = useState('');
  const [effectiveFrom, setEffectiveFrom] = useState('');

  const fetchCosts = async () => {
    if (!record || !record.id) return;
    setLoading(true);
    try {
      const { data } = await dataProvider('GET_LIST', 'whatsapp_message_type_cost', {
        filter: { message_type_id: record.id },
        pagination: {},
        sort: { field: 'effective_from', order: 'DESC' },
      });
      setCosts(data);
    } catch (err) {
      alert('Não foi possível carregar o histórico de custo.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record && record.id]);

  const addCost = async () => {
    if (!unitCost) {
      alert('Informe o custo unitário.');
      return;
    }
    setLoading(true);
    try {
      await dataProvider('CREATE', 'whatsapp_message_type_cost', {
        data: {
          message_type_id: record.id,
          unit_cost: unitCost,
          currency: 'USD',
          effective_from: effectiveFrom || undefined,
        },
      });
      setUnitCost('');
      setEffectiveFrom('');
      await fetchCosts();
    } catch (err) {
      alert('Não foi possível salvar o novo custo.');
      setLoading(false);
    }
  };

  if (!record || !record.id) {
    return null;
  }

  return (
    <div style={{ marginTop: 24, width: '100%', maxWidth: 560 }}>
      <h3 style={{ fontSize: 16, fontWeight: 500 }}>Histórico de custo</h3>
      {loading && <Loading />}
      {!loading && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={headCellStyle}>Vigente a partir de</TableCell>
              <TableCell style={headCellStyle}>Custo unitário</TableCell>
              <TableCell style={headCellStyle}>Moeda</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {costs.map(cost => (
              <TableRow key={cost.id}>
                <TableCell>{cost.effectiveFrom}</TableCell>
                <TableCell>{cost.unitCost}</TableCell>
                <TableCell>{cost.currency}</TableCell>
              </TableRow>
            ))}
            {costs.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} style={{ color: '#999' }}>Nenhum custo cadastrado ainda.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
      <div style={{ marginTop: 16, display: 'flex', gap: 12, alignItems: 'flex-end' }}>
        <TextField
          label="Novo custo unitário (US$)"
          type="number"
          inputProps={{ step: '0.000001' }}
          value={unitCost}
          onChange={e => setUnitCost(e.target.value)}
        />
        <TextField
          label="Vigente a partir de"
          type="date"
          helperText="Default: hoje"
          value={effectiveFrom}
          onChange={e => setEffectiveFrom(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button variant="outlined" color="primary" onClick={addCost}>Adicionar vigência</Button>
      </div>
    </div>
  );
};

export default CostHistory;
